import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  Login (URL, obj, success, error) {
    Vue.axios.post(URL + 'auth/login', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  OAuth (URL, obj, success, error) {
    Vue.axios.post(URL + 'auth/token', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  QRcode (URL, obj, success, error) {
    Vue.axios.post(URL + 'auth/qrcode', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  Revoke (URL, obj, success, error) {
    Vue.axios.post(URL + 'auth/revoke', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getMenuList (URL, header, success, error) {
    Vue.axios.get(URL + 'menus', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getRole (URL, header, success, error) {
    Vue.axios.get(URL + 'roles', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getPermission (URL, roleID, header, success, error) {
    Vue.axios.get(URL + 'permission/' + roleID, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  checkPermiss (URL, menuId, header, success, error) {
    Vue.axios.get(URL + 'checkpermission/' + menuId, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateMenus (URL, obj, header, success, error) {
    Vue.axios.put(URL + 'permission', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getConfig (URL, header, success, error) {
    Vue.axios.get(URL + 'config', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getProfile (URL, header, success, error) {
    Vue.axios.get(URL + 'user/profile', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateProfile (URL, obj, header, success, error) {
    Vue.axios.put(URL + 'user/profile', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  changePass (URL, obj, header, success, error) {
    Vue.axios.put(URL + 'user/password', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/services.js